import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getSideBarMenuData } from "../store/actions";
import AppRoute from "./route";
import { authProtectedRoutes } from "./index";
import Layouts from "../components/Layout";

class ProtectedRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {

    this.props.onGetSideBarMenuData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sideBarMenuData !== this.props.sideBarMenuData) {
      this.setState({ sideBarMenuData: this.props.sideBarMenuData });
    }
  }

  render() {
    return (
      <React.Fragment>
        {authProtectedRoutes.map((route, idx) => (
          <AppRoute
            path={route.path}
            layout={Layouts}
            component={route.component}
            key={route.path}
            page={route.page ?? ""}
            isAuthProtected={this.props.isAuthProtected}
            exact
          />
        ))}
      </React.Fragment>
    );
  }
}

ProtectedRoutes.propTypes = {
  sideBarMenuData: PropTypes.any,
  onGetSideBarMenuData: PropTypes.func,
  isAuthProtected: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    ...state.Layout,
    sideBarMenuData: state.Layout.sideBarMenuData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetSideBarMenuData: () => dispatch(getSideBarMenuData()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProtectedRoutes));
